import {Options} from '../Config/Options.js';
import $ from 'jquery';

const questions = {
  q1: ['q2a','q2b'],
  q2a: ['q3a','q3b'],
  q2b: ['q3b','q3c'],
  q3a: ['q4a','q4b'],
  q3b: ['q4b','q4c'],
  q3c: ['q4c','q4d'],
  q4a: ['q5a','q5b'],
  q4b: ['q5b','q5c'],
  q4c: ['q5c','q5d'],
  q4d: ['q5d','q5e'],
  q5a: [1,2],
  q5b: [2,3],
  q5c: [3,4],
  q5d: [4,5],
  q5e: [5,6]
}

const showQuestion = (idx, next=0) => {
  if($('#js-diagnosis').hasClass('is-complete')) return;
  $('#js-diagnosis .js-inquiry').eq(idx).addClass(function() {
    const $this = $(this);
    if(idx > 0) {
      $this.attr('data-question', next);
    }
    setTimeout(function() {
      let shift = $this.offset().top;
      if($('#js-diagnosis .js-inquiry').index($this) > 0) {
        shift -= $('#js-diagnosis .js-step').outerHeight() + $('#js-header').outerHeight()
      } else {
        shift = 0;
      }
      $this.addClass(Options.actView);
      $('html,body').animate({scrollTop: shift}, 600);
    },300)
    return Options.act;
  });
}

const resetQuestion = (idx) => {
  if($('#js-diagnosis').hasClass('is-complete')) return;
  $('#js-diagnosis .js-inquiry').eq(idx).nextAll()
    .removeClass(Options.act)
    .removeClass(Options.actView)
    .attr('data-question', '');
}

const answerQuestion = (name) => {
  if($('#js-diagnosis').hasClass('is-complete')) return;
  $('#js-diagnosis [name="' + name + '"]').on('change', function() {
    const parent = $(this).closest('.js-inquiry');
    const index = $('#js-diagnosis .js-inquiry').index(parent);
    console.log(index);
    const value = $(this).val();
    const next = questions[name][value];
    if(index < 4) {
      resetQuestion(index);
      showQuestion(index + 1,next);
      $('#js-diagnosis .js-step').attr('data-step', 5 - index - 1);
    } else {
      $('#js-diagnosis .js-step').attr('data-step', 0);
      $('#js-diagnosis .js-result').attr('data-type', next).fadeIn(function() {
        $('#js-diagnosis').addClass('is-complete');
        $('html,body').animate({scrollTop: $('#js-diagnosis .js-result').offset().top}, 600);
      });
    }
  });
}

const Diagnosis = () => {
  const targetElm = document.getElementById('js-diagnosis');
  if (!targetElm) return;
  const keys = Object.keys(questions);
  showQuestion(0);
  for(const key of keys) {
    answerQuestion(key);
  }
}

export default Diagnosis;